import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { DUEL_GROUP } from 'src/constants/queryKeys';

export const networkGetDuelInfo = async (duelId) => {
  const res = await axiosInstance.post(`Duel/Info/${duelId}`);
  return res;
};

export const networkGetDuelList = async (pageIndex = 0, pageSize = 50, data) => {
  const res = await axiosInstance.post(`Duel/ListPanel/${pageIndex}/${pageSize}`, data);
  return res;
};

export function useFetchDuelList(pageIndex = 0, pageSize = 50, data) {
  return useQuery({
    queryKey: ['app-duel-list', data, pageIndex],
    queryFn: () => networkGetDuelList(pageIndex, pageSize, data),
  });
}

export const networkGetDuelGiftList = async (duelId) => {
  const res = await axiosInstance.post(`DuelGift/List/${duelId}`);
  return res;
};

export function useGetDuelGiftList(duelId) {
  return useQuery({
    queryKey: ['app-duel-gift', duelId],
    queryFn: () => networkGetDuelGiftList(duelId),
  });
}

export const networkGetDuelUpdateList = async (duelId, payload) => {
  const res = await axiosInstance.post(`DuelGift/Update/${duelId}`, payload);
  return res;
};

export const networkGetDuelRemoveList = async (duelId) => {
  const res = await axiosInstance.post(`DuelGift/Remove/${duelId}`);
  return res;
};

export const networkGetDuelInsertList = async (data) => {
  const res = await axiosInstance.post(`DuelGift/Insert`, data);
  return res;
};

export const networkGetDuelLeaderboardList = async (duelId, PageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Scoreboard/${duelId}/${PageIndex}/${pageSize}`);
  return res;
};

export const networkRemoveDuel = async (duelId) => {
  const res = await axiosInstance.post(`Duel/Remove/${duelId}`);
  return res;
};

export const networkCreateDuel = async (data) => {
  const res = await axiosInstance.post('Duel/Insert', data);
  return res;
};

export const networkUpdateDuel = async (duelId, data) => {
  const res = await axiosInstance.post(`Duel/Update/${duelId}`, data);
  return res;
};

// --------------------------------------------------------------------------

export const networkGetDuelGroup = async (PageIndex = 0, PageSize = 30, AppId) => {
  const res = await axiosInstance.post(`DuelGroup/List/${PageIndex}/${PageSize}/${AppId}`);
  return res;
};

export function useFetchDuelGroup(pageIndex = 0, pageSize = 50, appId) {
  return useQuery({
    queryKey: [DUEL_GROUP, appId, pageIndex, pageSize],
    queryFn: () => networkGetDuelGroup(pageIndex, pageSize, appId),
  });
}

export const networkDuelGroupMove = async (projectId, payload) => {
  const res = await axiosInstance.post(`Duel/Move/${projectId}`, payload);
  return res;
};
